// extracted by mini-css-extract-plugin
module.exports = {"eventsTable":"PeriodAcademicCalendarTable_eventsTable__2F6fP"};